import { NgModule } from '@angular/core';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaginationModule } from '@targx/components/pagination/pagination.module';

import { AutodepocaSharedModule } from './autodepoca-shared.module';
import { AutodepocaRoutingModule } from './autodepoca-routing.module';

import { ShellComponent } from './shared/shell/shell.component';
import { AdeHeaderComponent } from './shared/header/header.component';
import { AdeFooterComponent } from './shared/footer/footer.component';
import { AdeCookieConsentComponent } from './shared/cookie-consent/cookie-consent.component';
import { AdeClassifiedCardComponent } from './shared/classified-card/classified-card.component';
import { DisplayProductsComponent } from './shared/widgets/display-products/display-products.component';

import { AdeHomeComponent } from './pages/home/home.component';
import { AdeDealerPageComponent } from './pages/dealer-page/dealer-page.component';
import { AdeListingComponent } from './pages/listing/listing.component';
import { AdeContentComponent } from './pages/content/content.component';
import { AdeVeiculoComponent } from './pages/veiculo/veiculo.component';
import { AdeArtigoComponent } from './pages/artigo/artigo.component';
import { AdePesquisaComponent } from './pages/pesquisa/pesquisa.component';

@NgModule({
  declarations: [
    ShellComponent,
    AdeHeaderComponent,
    AdeFooterComponent,
    AdeCookieConsentComponent,
    AdeClassifiedCardComponent,
    DisplayProductsComponent,
    AdeHomeComponent,
    AdeDealerPageComponent,
    AdeListingComponent,
    AdeContentComponent,
    AdeVeiculoComponent,
    AdeArtigoComponent,
    AdePesquisaComponent,
  ],
  imports: [
    AutodepocaSharedModule,
    FuseLoadingBarModule,
    MatProgressSpinnerModule,
    PaginationModule,
    AutodepocaRoutingModule,
  ],
  exports: [AdeHeaderComponent, AdeFooterComponent, AdeCookieConsentComponent],
})
export class AutodepocaModule {}
